import React, { useEffect, useState } from 'react';
import { Layout, Menu, Typography, Space, Button } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined, KeyOutlined, ReloadOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import UserApproval from './UserApproval';
import RoleAssign from './RoleAssign';
import RestartGateway from './RestartGateway';

const { Content, Sider } = Layout;
const { Title, Text } = Typography;

const PermissionManagement = () => {
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState('user-approval');
  const [collapsed, setCollapsed] = useState(false);

  const menuItems = [
    {
      key: 'role-assign',
      icon: <KeyOutlined />,
      label: '权限管理',
      description: '管理员为用户分配角色',
    },
    {
      key: 'user-approval',
      icon: <UserOutlined />,
      label: '用户审批',
      description: '审批新注册用户登录权限',
    },
    {
      key: 'restart-gateway',
      icon: <ReloadOutlined />,
      label: '重启Gateway',
      description: '重启IB Gateway服务',
    },
  ];

  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search || '');
      const key = params.get('key');
      if (key && menuItems.some((item) => item.key === key)) {
        setSelectedKey(key);
      }
    } catch (e) {
      // ignore
    }
  }, [location.search, menuItems]);

  const renderContent = () => {
    switch (selectedKey) {
      case 'role-assign':
        return <RoleAssign />;
      case 'user-approval':
        return <UserApproval />;
      case 'restart-gateway':
        return <RestartGateway />;
      default:
        return <RoleAssign />;
    }
  };

  return (
    <div
      style={{
        height: '100vh',
        background: '#f5f5f5',
        overflow: 'hidden',
      }}
    >
      <Layout
        style={{
          height: '100vh',
          background: '#f5f5f5',
          overflow: 'hidden',
        }}
      >
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          width={320}
          collapsedWidth={80}
          style={{
            background: '#fff',
            borderRight: '1px solid #f0f0f0',
            boxShadow: '2px 0 8px rgba(0,0,0,0.06)',
            display: 'flex',
            flexDirection: 'column',
          }}
          trigger={null}
        >
          <div
            style={{
              padding: collapsed ? '16px 8px' : '20px 16px 16px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: '#fff',
              position: 'relative',
              minHeight: collapsed ? '60px' : 'auto',
            }}
          >
            {!collapsed && (
              <>
                <Title level={4} style={{ color: '#fff', margin: 0, marginBottom: '8px' }}>
                  权限管理
                </Title>
                <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px' }}>账号审批与权限配置</Text>
              </>
            )}

            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                color: '#fff',
                border: 'none',
                width: '32px',
                height: '32px',
                borderRadius: '6px',
                background: 'rgba(255,255,255,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            />
          </div>

          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
            <Menu
              mode="inline"
              selectedKeys={[selectedKey]}
              onClick={({ key }) => setSelectedKey(key)}
              style={{
                border: 'none',
                background: 'transparent',
                padding: collapsed ? '8px 0' : '16px 0',
                flex: 1,
                minHeight: 0,
              }}
              inlineCollapsed={collapsed}
            >
              {menuItems.map((item) => (
                <Menu.Item
                  key={item.key}
                  style={{
                    margin: collapsed ? '4px 8px' : '4px 12px',
                    borderRadius: '8px',
                    transition: 'all 0.3s ease',
                    border: selectedKey === item.key ? '1px solid #1890ff' : '1px solid transparent',
                    background: selectedKey === item.key ? '#f0f8ff' : 'transparent',
                    minHeight: collapsed ? '52px' : '72px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: collapsed ? 'center' : 'flex-start',
                    padding: collapsed ? '14px 8px' : '14px 18px',
                  }}
                >
                  {collapsed ? (
                    item.icon
                  ) : (
                    <Space size={12} align="center" style={{ width: '100%' }}>
                      <div
                        style={{
                          color: selectedKey === item.key ? '#1890ff' : '#8c8c8c',
                          fontSize: '18px',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {item.icon}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontWeight: '600',
                            fontSize: '16px',
                            color: selectedKey === item.key ? '#1890ff' : '#262626',
                            marginBottom: '2px',
                          }}
                        >
                          {item.label}
                        </div>
                        <div
                          style={{
                            fontSize: '13px',
                            color: selectedKey === item.key ? '#40a9ff' : '#8c8c8c',
                            lineHeight: '1.4',
                          }}
                        >
                          {item.description}
                        </div>
                      </div>
                    </Space>
                  )}
                </Menu.Item>
              ))}
            </Menu>
          </div>
        </Sider>

        <Layout
          style={{
            background: '#f5f5f5',
            padding: '24px',
            height: '100%',
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: '12px',
              padding: '24px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              height: '100%',
              overflow: 'hidden',
            }}
          >
            <Content
              style={{
                background: 'transparent',
                padding: 0,
                height: '100%',
                overflow: 'auto',
              }}
            >
              {renderContent()}
            </Content>
          </div>
        </Layout>
      </Layout>
    </div>
  );
};

export default PermissionManagement;
